import React, { useState } from 'react';
import { Loader2, KeyRound } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { toast } from 'sonner';
import api, { formatApiError } from '../api';
import { useAuth } from '../AuthContext';

const ChangePasswordForm = () => {
  const { user } = useAuth();
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next.length < 6) { toast.error('Minimum 6 caractères'); return; }
    if (next !== confirm) { toast.error('Les mots de passe ne correspondent pas'); return; }
    setLoading(true);
    try {
      await api.post('/auth/change-password', { current_password: current, new_password: next });
      toast.success('Mot de passe mis à jour');
      setCurrent(''); setNext(''); setConfirm('');
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-xl" data-testid="account-page">
      <h1 className="text-2xl font-bold text-neutral-900 mb-1">Mon compte</h1>
      <p className="text-neutral-500 mb-6">{user?.email}</p>

      <div className="bg-white rounded-xl border border-neutral-200 p-6">
        <h2 className="font-bold text-neutral-900 mb-4 flex items-center gap-2"><KeyRound className="w-4 h-4" />Changer de mot de passe</h2>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label>Mot de passe actuel</Label>
            <Input type="password" value={current} onChange={(e) => setCurrent(e.target.value)} required data-testid="current-password-input" />
          </div>
          <div>
            <Label>Nouveau mot de passe</Label>
            <Input type="password" value={next} onChange={(e) => setNext(e.target.value)} required data-testid="new-password-input" />
          </div>
          <div>
            <Label>Confirmer</Label>
            <Input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required data-testid="confirm-password-input" />
          </div>
          <Button type="submit" disabled={loading} className="bg-red-700 hover:bg-red-600" data-testid="change-password-button">
            {loading && <Loader2 className="w-4 h-4 animate-spin mr-2" />}Mettre à jour
          </Button>
        </form>
      </div>
    </div>
  );
};

export default ChangePasswordForm;
